import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=243c9584&scoped=true&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&id=243c9584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243c9584",
  null
  
)

export default component.exports